module.exports = __webpack_public_path__ + "static/media/bungalowvip3.846b21ee.jpg";